var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "list_svg__nc-icon-wrapper",
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#86AE43",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2h50v60H7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M31 18h16M16 18l2 2 6-6M31 32h16M16 32l2 2 6-6M31 46h16"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 19,
    cy: 46,
    r: 3
  }))));
}

export default SvgList;